import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/push-tracking-status.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "enum---pushtrackingstatus"
    }}>{`Enum - PushTrackingStatus`}</h1>
    <p>{`Enum representing the status of push tracking.`}</p>
    <h2 {...{
      "id": "definition"
    }}>{`Definition`}</h2>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&function=enum" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&function=enum" mdxType="Tabs" />
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&function=string-values" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&function=string-values" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      